export default "__VITE_ASSET__Bj48ecF___"